"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OUTPUT_CHECKOUT_VALS = exports.INPUT_CHECKOUT_VALS = exports.INPUT_CHECK_IN_VALS = exports.DATE_FORMAT = void 0;
const DATE_FORMAT = 'yyyy-MM-dd';
exports.DATE_FORMAT = DATE_FORMAT;
const INPUT_CHECK_IN_VALS = {
    BEING_IN_PAST: 'INVALID_DUE_TO_BEING_IN_PAST',
    CHANGEOVER_EXCLUSION: 'INVALID_DUE_TO_CHANGEOVER_EXCLUSION',
    MAX_FUTURE_BOOKING: 'INVALID_DUE_TO_MAX_FUTURE_BOOKING',
    MIN_PRIOR_NOTIFICATION: 'INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION',
    MIN_STAY_NOT_ACHIEVABLE: 'INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE',
    NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS: 'INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS',
    NON_CHANGEOVER_DAY_OF_WEEK: 'INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK',
    NOT_AVAILABLE: 'INVALID_DUE_TO_NOT_AVAILABLE',
    VALID: 'VALID',
};
exports.INPUT_CHECK_IN_VALS = INPUT_CHECK_IN_VALS;
const INPUT_CHECKOUT_VALS = {
    CHANGEOVER_EXCLUSION: 'INVALID_DUE_TO_CHANGEOVER_EXCLUSION',
    NON_CHANGEOVER_DAY_OF_WEEK: 'INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK',
    VALID: 'VALID',
};
exports.INPUT_CHECKOUT_VALS = INPUT_CHECKOUT_VALS;
const OUTPUT_CHECKOUT_VALS = {
    CHANGEOVER_EXCLUSION: 'INVALID_DUE_TO_CHANGEOVER_EXCLUSION',
    CHECKOUT_BEFORE_CHECKIN: 'INVALID_DUE_TO_CHECKOUT_BEFORE_CHECKIN',
    MAX_STAY_WINDOW_EXCEEDED: 'INVALID_DUE_TO_MAX_STAY_WINDOW_EXCEEDED',
    MIN_STAY_NOT_MET: 'INVALID_DUE_TO_MIN_STAY_NOT_MET',
    NON_CHANGEOVER_DAY_OF_WEEK: 'INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK',
    VALID: 'VALID',
};
exports.OUTPUT_CHECKOUT_VALS = OUTPUT_CHECKOUT_VALS;
